<template>
  <md-button>Zurück zum Dashboard</md-button>
</template>

<script>
export default {
  mounted() {
    let email = { email: this.$route.query.email };
    this.$store
      .dispatch("garmin")
      .then(() => {
        this.$router.push("/").catch(err => {
          console.log(err);
          throw new Error(`Problem handling something: ${err}.`);
        });
        // Tell user he's registered
        this.$notify({
          timeout: 5000,
          message: "Du bist jetzt mit Garmin verbunden!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success"
        });
      })
      .catch(err => {
        this.$notify({
          timeout: 5000,
          message: err.message,
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "error"
        });
      });
  }
};
</script>

<style></style>
